import React from "react";
import PropTypes from "prop-types";
import CustomImage from "../../../components/atoms/customImage";
import isEmpty from "lodash.isempty";
import { formatClassNames } from "../../../utils/common";
import { cleverTapCommonEvents, cleverTapCommonWords } from "../../../analytics/clevertapConstants";
import useAnalytics from "../../../analytics/useAnalytics";
import { useDispatch } from "react-redux";
import { setIsNavigatingAction } from "../../../store/slices/commonSlice";

/** */
const SingleImageBannerSection = ({ category, isFromSearch = false, dimensions, isMobile = false }) => {
  const { trackEvent } = useAnalytics();
  const dispatch = useDispatch();
  const isFullWidth = category?.is_full_width ? category?.is_full_width : false;
  const pageBannerData = {
    page_name: isFromSearch ? cleverTapCommonWords.AutoSuggestions : cleverTapCommonWords.HOME,
    page_type: isFromSearch ? cleverTapCommonWords.AutoSuggestions : cleverTapCommonWords.HOME,
  };

  if (isEmpty(category) || isEmpty(category?.banner_image_url)) {
    return null;
  }

  /** returns the source string for banner */
  const returnImgBannerSrc = () => {
    if (isFromSearch) {
      if (isMobile) {
        return category?.banner_image_url;
      } else {
        return category?.banner_image_url_dsite;
      }
    } else {
      return category?.banner_image_url;
    }
  };

  /**
   *
   * @returns the recurring element
   */
  const returnBanner = () => {
    return (
      <CustomImage
        src={returnImgBannerSrc() || "/icons/placeholder-bb.png"}
        alt={category?.altTag}
        width={dimensions?.width}
        height={dimensions?.height}
        customStyle={{ width: "100%", height: "100%" }}
        borderRadius={isFullWidth ? 0 : 16}
        className="object-cover"
      />
    );
  };

  return (
    <>
      <div
        className={formatClassNames(
          "flex w-full items-center justify-center",
          isFullWidth ? "px-0" : isFromSearch ? "px-16" : "px-16 md:px-40",
        )}
      >
        {category?.category_link ? (
          <a
            href={category?.category_link}
            className={formatClassNames(
              "flex w-full items-center justify-center overflow-hidden",
              !isFullWidth && "rounded-16",
            )}
            // eslint-disable-next-line react/jsx-handler-names
            onClick={() => {
              dispatch(setIsNavigatingAction(true));
              trackEvent(
                cleverTapCommonEvents.bannerClicked,
                {
                  ...pageBannerData,
                  banner_id: cleverTapCommonWords?.SINGLE_IMAGE_BANNER,
                  banner_name: cleverTapCommonWords?.SINGLE_IMAGE_BANNER,
                },
                ["clevertap"],
              );
            }}
          >
            {returnBanner()}
          </a>
        ) : (
          <div
            className={formatClassNames(
              "flex w-full items-center justify-center overflow-hidden",
              !isFullWidth && "rounded-16",
            )}
          >
            {returnBanner()}
          </div>
        )}
      </div>
    </>
  );
};

SingleImageBannerSection.propTypes = {
  category: PropTypes.object,
  dimensions: PropTypes.object,
  isFromSearch: PropTypes.bool,
  isMobile: PropTypes.bool,
};

export default SingleImageBannerSection;
